export const heads = [
	{
		id: 4565654,
		url: '#what_it_this',
		text: 'What is this',
	},
	{
		id: 4858945,
		url: '#How_to_use',
		text: 'How to use',
	},
	{
		id: 3243464,
		url: '#Manual_download',
		text: 'Manual Download?',
	},
	{
		id: 3243465,
		url: '#How_does_it_work',
		text: 'How does it work ?',
	},
	{
		id: 454985,
		url: '#Brought_to_you_by_StakePool247',
		text: 'Brought to you by StakePool247.io',
	},
	{
		id: 9384,
		url: '#Disclaimers',
		text: 'Disclaimers',
	},
];

export const appsDetails = [
	{
		id: 349,
		title: 'Cardano Mainnet',
		subtitle: 'networkMagic: 764824073',
		description: 'Cardano Full Blockchain Snapshot for the Mainnet ',
		downloadLink: '#',
		seemore: '/mainnet',
	},
	{
		id: 649,
		title: 'Cardano PreProd',
		subtitle: 'networkMagic: 1',
		description: 'Cardano Full Blockchain Snapshot for the Testnet',
		downloadLink: '#',
		seemore: '/testnet',
	},
];

// Project archived: nav links removed so the only download/info subpages
// are no longer reachable. The logo still links back to the home page.
export const pages = [];
